import { PopupService } from '@usitsdasdesign/dds-ng/core/popup';
import * as ɵngcc0 from '@angular/core';
import { Injectable } from '@angular/core';

class CustomPopupService extends PopupService {
  static ɵfac: ɵngcc0.ɵɵFactoryDef<CustomPopupService, never>;
  static ɵprov: ɵngcc0.ɵɵInjectableDef<CustomPopupService>;
}

@Injectable()
export class TooltipService extends CustomPopupService {

}
